screenSharePresenter.service('screenShareService', [
    '$rootScope',
    '$window',
    'logService',
    'config',
    'meetingService',
    'vertoService',
    'helperService',
    'configService',
    'contentService',
    'analyticsWrapperService',
    'avDeviceService',
    'brandingService',
    'localizationService',
    'supportLinkService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $window,
        logService,
        config,
        meetingService,
        vertoService,
        helperService,
        configService,
        contentService,
        analyticsWrapperService,
        avDeviceService,
        brandingService,
        localizationService,
        supportLinkService,
        executionEnvironmentEnum
    ) {
        const logger = logService.createLoggerWithSource('screenShareService');

        var email;
        var extensionInstalled = false;
        var waitingForInstall = false;
        var isChrome = helperService.isChrome();
        var isElectron = helperService.isElectron();
        var chromeWebStorePopUp;

        var camaroSfuScreenShareStream = null;
        let screensharePermission = null;

        var useVideoStream = undefined;
        var videoParams = {};

        var service = {
            startScreenShare: startScreenShare,
            stopScreenShare: stopScreenShare,
            getExtensionInstalled: getExtensionInstalled,
            setExtensionInstalled: setExtensionInstalled,
            showInstallationPrompt: showInstallationPrompt,
            isWaitingForInstall: isWaitingForInstall,
            endWaitForInstall: endWaitForInstall,
            startScreenShareVertoCall: startScreenShareVertoCall,

            //Chrome Web Store
            showChromeWebStorePrompt: showChromeWebStorePrompt,
            openChromeWebStore: openChromeWebStore,
            closeChromeWebStore: closeChromeWebStore,

            getScreenShareExtensionURL: getScreenShareExtensionURL,

            finalizeScreenShareInit: finalizeScreenShareInit,

            getCamaroSfuScreenShareStream: getCamaroSfuScreenShareStream,
            setCamaroSfuScreenShareStream: setCamaroSfuScreenShareStream,
            recreateCamaroSfuScreenShareStream: recreateCamaroSfuScreenShareStream,

            getBordersOverlay: getBordersOverlay,

            getHasScreensharePermission: getHasScreensharePermission,
            triggerScreensharePermissionsSystemDialog: triggerScreensharePermissionsSystemDialog,

            notifyUserAppIsClosedOrMinimized: notifyUserAppIsClosedOrMinimized,

            // Citrix V4 API
            startScreenShare_citrixV4: startScreenShare_citrixV4
        };

        $rootScope.$on('electron-screen-selected', function (e, data) {
            logger.log('received electron-screen-selected event');

            useVideoStream = undefined;

            // Create VDI reference once for multiple uses
            const vdiRef = helperService.getVDIRef();

            // Check if this is a Citrix V4 screen share
            if (helperService.isCitrixSDKVersionFour?.() && data.id) {
                service.startScreenShare_citrixV4(data);
                return;
            }
            // Original Electron code follows
            // Ref ANYAM-92585
            const fixScreenScale = configService.getValue('fixScreenScale') !== 'false'; // default is true
            videoParams = {
                chromeMediaSource: 'desktop',
                chromeMediaSourceId: data.id,
                maxWidth: fixScreenScale
                    ? Math.ceil($window.screen.width * $window.devicePixelRatio)
                    : $window.screen.width,
                maxHeight: fixScreenScale
                    ? Math.ceil($window.screen.height * $window.devicePixelRatio)
                    : $window.screen.height
            };
            const isNonVDI = vdiRef.getVdiType() === executionEnvironmentEnum.NonVDI;
            logger.log(
                'electron-screen-selected',
                `hasFixScreenSimple=${configService.hasFixScreenSimple}, isNonVDI=${isNonVDI}, `
            );
            if (configService.hasFixScreenSimple && isNonVDI) {
                delete videoParams.maxWidth;
                delete videoParams.maxHeight;
            }

            //If SFU mode, manually retrieve screenshare stream before calling playContent...
            //finalizeScreenShareInit will call playContent which will trigger content-initiating state
            if (meetingService.getIsSfuEnabled()) {
                const constraints = { video: { mandatory: videoParams }, audio: false };
                logger.log('electron sfu: manually retrieving screenshare stream with constraints: ', constraints);
                avDeviceService
                    .getStream(constraints)
                    .then(function (stream) {
                        logger.log('electron sfu: successfully retrieved screenshare stream');
                        service.setCamaroSfuScreenShareStream(stream);
                        service.finalizeScreenShareInit();
                    })
                    .catch(function (e) {
                        logger.error(
                            'electron-screen-selected',
                            'electron sfu: error retrieving screenshare stream',
                            e
                        );

                        if (e instanceof DOMException && vdiRef.shareApplicationScreen && data.id.includes('window')) {
                            service.notifyUserAppIsClosedOrMinimized(data.id);
                        }
                        contentService.cancelContentInitiation();
                    });
            } else {
                service.finalizeScreenShareInit();
            }
        });

        $window.addEventListener('message', function (event) {
            if (event.origin != $window.location.origin) return;

            // Chrome: user chose a stream
            if (event.data.type && event.data.type === 'SS_DIALOG_SUCCESS') {
                useVideoStream = undefined;
                videoParams = {
                    chromeMediaSource: 'desktop',
                    chromeMediaSourceId: event.data.streamId,
                    maxWidth: $window.screen.width,
                    maxHeight: $window.screen.height
                };
                if (configService.hasFixScreenSimple) {
                    delete videoParams.maxWidth;
                    delete videoParams.maxHeight;
                }

                if (!contentService.isContentInitiating() && !contentService.isContentPlaying()) {
                    contentService.playContent('screenshare');

                    logger.log('User selected a window for Chrome screensharing');

                    analyticsWrapperService.eventTrack('Meeting - Screen Sharing - Selected window to share', {
                        category: 'Screen Sharing'
                    });
                }
            }

            // Chrome: user clicked on 'cancel' in choose media dialog
            if (event.data.type && event.data.type === 'SS_DIALOG_CANCEL') {
                logger.log('User cancelled Chrome Screenshare initiation');

                analyticsWrapperService.eventTrack('Meeting - Screen Sharing - Cancelled Screenshare Dialog Prompt', {
                    category: 'Screen Sharing'
                });
            }

            if (event.data.type && event.data.type === 'SS_UI_ERROR') {
                logger.error('SS_UI_ERROR', 'Error trying to use the Chrome Screenshare Extension', {
                    category: 'screen-share-extension'
                });
            }
        });

        return service;

        ////////////////////////

        function finalizeScreenShareInit() {
            if (!contentService.isContentInitiating() && !contentService.isContentPlaying()) {
                if (meetingService.getIsSfuEnabled() && helperService.isElectron()) {
                    //Should only be broadcasted if Electron in SFU mode
                    $rootScope.$broadcast('start-sfu-screenshare');
                } else {
                    contentService.playContent('screenshare');
                }

                logger.log('User selected a window for electron screensharing');

                analyticsWrapperService.eventTrack('Meeting - Screen Sharing - Selected window to share', {
                    category: 'Screen Sharing'
                });
            } else if (
                contentService.getContentType() == 'screenshare' &&
                meetingService.getIsSfuEnabled() &&
                helperService.isElectron()
            ) {
                var hasMultishare = configService.getHasMultishare();
                if (hasMultishare) {
                    $rootScope.$broadcast('start-sfu-screenshare');
                    analyticsWrapperService.eventTrack('Meeting - Screen Sharing - Selected window to share', {
                        category: 'Screen Sharing'
                    });
                }
            }
        }

        function notifyUserAppIsClosedOrMinimized(sourceId) {
            let sharedAppInFocus = false;
            const types = ['screen', 'window'];
            let getSourcesOptions;
            if (helperService.getIsRedesign() === true) {
                getSourcesOptions = { types: types, fetchWindowIcons: true };
            } else {
                //TODO: REMOVE POST-REDESIGN
                getSourcesOptions = { types: types };
            }
            $window.preloadedApi.desktopCapturer.getSources(getSourcesOptions).then(sources => {
                sources.forEach(function (source) {
                    if (source.id === sourceId) {
                        sharedAppInFocus = true;
                    }
                });
                if (!sharedAppInFocus) {
                    // show error
                    var swalOptions;
                    const promptTitle = localizationService.translate(
                        'SCREENSHARE.DIALOG.SELECTED_APPLICATION_CLOSED_OR_MINIMIZED.TITLE'
                    );
                    const promptMsg = localizationService.translate(
                        'SCREENSHARE.DIALOG.SELECTED_APPLICATION_CLOSED_OR_MINIMIZED.TEXT'
                    );
                    var closeButtonHtml =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    swalOptions = {
                        title: helperService.getIsRedesign() === true ? closeButtonHtml + promptTitle : promptTitle,
                        text: promptMsg,
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        html: true
                    };
                    $window.swal(swalOptions);
                }
            });
        }

        function getCamaroSfuScreenShareStream() {
            return camaroSfuScreenShareStream;
        }

        function setCamaroSfuScreenShareStream(newStream) {
            camaroSfuScreenShareStream = newStream;
        }

        function startScreenShareVertoCall() {
            vertoService.startScreenShare({
                callerID: email,
                videoParams: videoParams,
                useStream: useVideoStream
            });
        }

        function recreateCamaroSfuScreenShareStream() {
            if (videoParams && meetingService.getIsSfuEnabled()) {
                const constraints = { video: { mandatory: videoParams }, audio: false };
                if (configService.hasFixScreenSimple) {
                    if (!Object.keys(videoParams).length) {
                        constraints.video = true;
                    }
                }
                return avDeviceService
                    .getStream(constraints)
                    .then(stream => {
                        logger.log('electron sfu: successfully recreated screenshare stream');
                        service.setCamaroSfuScreenShareStream(stream);
                        return stream;
                    })
                    .catch(e => {
                        logger.error(
                            'recreateCamaroSfuScreenShareStream',
                            'electron sfu: error recreate screenshare stream',
                            e
                        );
                    });
            } else {
                logger.error('recreateCamaroSfuScreenShareStream', 'cannot recreate screenshare stream', {
                    videoParams: !!videoParams,
                    getIsSfuEnabled: meetingService.getIsSfuEnabled()
                });
                return Promise.resolve(undefined);
            }
        }

        function startScreenShare(newEmail) {
            email = newEmail;

            if (isElectron) {
                //open the local Screen Share selection dialog for electron
                $rootScope.$broadcast('show-modal', 'electronScreen');
            } else if (isChrome) {
                if ($window.navigator.mediaDevices?.getDisplayMedia) {
                    const screenMediaConstraints = {
                        video: {
                            width: {
                                ideal: 1920
                            }
                        }
                    };
                    if (configService.hasFixScreenSimple) {
                        screenMediaConstraints.video = true;
                    }
                    $window.navigator.mediaDevices.getDisplayMedia(screenMediaConstraints).then(
                        stream => {
                            if (!configService.hasFixScreenSimple) {
                                try {
                                    stream.getTracks()[0].applyConstraints({ frameRate: 5 });
                                } catch (e) {}
                            }
                            useVideoStream = stream;
                            videoParams = {
                                maxWidth: $window.screen.width,
                                maxHeight: $window.screen.height
                            };
                            if (configService.hasFixScreenSimple) {
                                delete videoParams.maxWidth;
                                delete videoParams.maxHeight;
                            }

                            if (!contentService.isContentInitiating() && !contentService.isContentPlaying()) {
                                contentService.playContent('screenshare');

                                logger.log('startScreenShare', 'User selected a window for Chrome screensharing');

                                analyticsWrapperService.eventTrack(
                                    'Meeting - Screen Sharing - Selected window to share',
                                    {
                                        category: 'Screen Sharing'
                                    }
                                );
                            }
                        },
                        error => {
                            const loggableErr = error && error.message ? error.message : error;
                            let cancelled = false;
                            let isCatalinaError = false;

                            if (loggableErr === 'Permission denied') {
                                logger.log('startScreenShare', 'User cancelled Chrome Screenshare initiation');
                                analyticsWrapperService.eventTrack(
                                    'Meeting - Screen Sharing - Cancelled Screenshare Dialog Prompt',
                                    {
                                        category: 'Screen Sharing'
                                    }
                                );
                                cancelled = true;
                            } else if (
                                helperService.isChromeOSXCatalina() &&
                                loggableErr === 'Permission denied by system'
                            ) {
                                isCatalinaError = true;
                            } else {
                                logger.error('startScreenShare', 'WebRTC error', loggableErr);
                            }

                            if (!cancelled) {
                                if (isCatalinaError) {
                                    const link = supportLinkService.getSupportLink('catalinaScreenShare');
                                    $window.swal({
                                        title: localizationService.translate(
                                            'SCREENSHARE.DIALOG.YOUR_MAC_NEEDS_PERMISSION_TO_SCREENSHARE'
                                        ),
                                        text: localizationService.translate(
                                            'SCREENSHARE.DIALOG.CLICK_HERE_TO_SOLVE_THIS_ISSUE',
                                            {
                                                link: link
                                            }
                                        ),
                                        type: 'warning',
                                        showCancelButton: false,
                                        showConfirmButton: true,
                                        confirmButtonText: 'OK',
                                        confirmButtonColor: brandingService.getBaseColor(),
                                        allowOutsideClick: false,
                                        html: true
                                    });
                                } else {
                                    $window.swal({
                                        title: localizationService.translate(
                                            'SCREENSHARE.DIALOG.WE_ARE_SORRY_THERE_IS_A_PROBLEM_WITH_SCREEN_SHARE'
                                        ),
                                        text: localizationService.translate(
                                            'SCREENSHARE.DIALOG.THERE_IS_A_PROBLEM_WITH_SCREEN_SHARE_TRY_AGAIN'
                                        ),
                                        type: 'warning',
                                        showCancelButton: false,
                                        showConfirmButton: true,
                                        confirmButtonText: 'OK',
                                        confirmButtonColor: brandingService.getBaseColor(),
                                        allowOutsideClick: false,
                                        html: false
                                    });
                                }
                            }
                        }
                    );
                } else {
                    $window.postMessage({ type: 'SS_UI_REQUEST', text: 'start' }, '*');
                    logger.log('startScreenShare', 'Opening Chrome Screenshare window selection popup');
                    service.closeChromeWebStore();
                }
            }
        }

        function stopScreenShare() {
            vertoService.stopScreenShare();
        }

        function setExtensionInstalled(val) {
            extensionInstalled = val;
            if (val === true) {
                logger.log('screen share extension installed', { category: 'screen-share-extension' });
            } else {
                logger.log('screen share extension not installed', { category: 'screen-share-extension' });
            }
        }

        function getExtensionInstalled() {
            if (isElectron || $window.navigator.mediaDevices?.getDisplayMedia) {
                return true;
            }

            return extensionInstalled;
        }

        function isWaitingForInstall() {
            return waitingForInstall;
        }

        function endWaitForInstall() {
            waitingForInstall = false;

            if (contentService.isContentPlaying()) {
                //Show override prompt
                contentService.promptUserOverride('screenshare');
                logger.log('ScreenShare extension installed - Calling promptUserOverride to override current content');
            } else {
                //No content playing, allow screenshare
                logger.log('Telling server to play new content:', 'screenshare');
                $rootScope.$broadcast('start-screenshare');
            }
        }

        function showInstallationPrompt() {
            waitingForInstall = true;

            if (isChrome) {
                service.showChromeWebStorePrompt();
            }
        }

        function showChromeWebStorePrompt() {
            var swalOptions;
            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            swalOptions = {
                title: closeButtonHtml + localizationService.translate('HEADER.DIALOG.SHARE_SCREEN_CHROME_TEXT'),
                text: '',
                showCancelButton: true,
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                confirmButtonText: localizationService.translate('HEADER.DIALOG.SHARE_SCREEN_CHROME_CONFIRM'),
                confirmButtonColor: brandingService.getBaseColor(),
                html: true
            };

            $window.swal(swalOptions, function (openPopUp) {
                if (openPopUp) {
                    service.openChromeWebStore();

                    analyticsWrapperService.eventTrack('Meeting - Screen Sharing - Clicked to open Chrome Web Store', {
                        category: 'Screen Sharing'
                    });
                } else {
                    analyticsWrapperService.eventTrack(
                        'Meeting - Screen Sharing - Clicked cancel for Chrome Web Store prompt',
                        {
                            category: 'Screen Sharing'
                        }
                    );
                }
            });
        }

        function openChromeWebStore() {
            chromeWebStorePopUp = $window.open(service.extensionURL, 'chrome-web-store', 'width=1000,height=600');
        }

        function closeChromeWebStore() {
            if (chromeWebStorePopUp) {
                chromeWebStorePopUp.close();
            }
        }

        // ScreenShare Extension URL
        function getScreenShareExtensionURL(optionalBrowser) {
            var host = helperService.getLocationHost(),
                reseller,
                environment,
                os,
                chromeScreenSharingExtensionURL;

            // reseller
            if (meetingService.isIntermediaPLRUser()) {
                reseller = 'intermediaPLR';
            } else if (brandingService.isUB()) {
                reseller = 'intermediaUB';
            } else {
                reseller = 'intermediaDirect';
            }

            // environment
            if (
                host === 'localhost' ||
                host.indexOf('-dev.com') !== -1 ||
                host.indexOf('-local.com') !== -1 ||
                host.indexOf('-qa.com') !== -1
            ) {
                environment = 'qa';
            } else if (host.indexOf('-staging.com') !== -1) {
                environment = 'staging';
            } else {
                environment = 'prod';
            }

            // Chrome SS url
            try {
                chromeScreenSharingExtensionURL =
                    'https://chrome.google.com/webstore/detail/' +
                    config.screenSharingExtensions.chrome[reseller][environment];
            } catch (e) {
                chromeScreenSharingExtensionURL = '';
            }

            if (
                (optionalBrowser && optionalBrowser.toLowerCase() === 'chrome') ||
                (isChrome &&
                    (optionalBrowser === undefined || (optionalBrowser && optionalBrowser.toLowerCase() !== 'firefox')))
            ) {
                return chromeScreenSharingExtensionURL;
            }

            // os
            if (helperService.isWindows()) {
                os = 'windows';
            } else if (helperService.isMac()) {
                os = 'mac';
            } else {
                return '';
            }

            if (isChrome) {
                return chromeScreenSharingExtensionURL;
            } else {
                return '';
            }
        }

        function getBordersOverlay(elementIdentifier) {
            var leftRightBlackBarSize = 0;
            var topBottomBlackBarSize = 0;
            var ratio = 0;

            var actualScreenshareWidth = $window.$(elementIdentifier)[0].videoWidth;
            var actualScreenshareHeight = $window.$(elementIdentifier)[0].videoHeight;

            var feedWidth = $window.$(elementIdentifier).innerWidth();
            var feedHeight = $window.$(elementIdentifier).innerHeight();

            var screenAspectRatio = actualScreenshareWidth / actualScreenshareHeight;
            var feedAspectRatio = feedWidth / feedHeight;

            if (screenAspectRatio > feedAspectRatio) {
                //screenshare is wider, blackbar on top/bottom
                ratio = feedWidth / actualScreenshareWidth;
                var convertedHeight = actualScreenshareHeight * ratio;
                topBottomBlackBarSize = (feedHeight - convertedHeight) / 2;
            } else {
                //black bar on left/right
                ratio = feedHeight / actualScreenshareHeight;
                var convertedWidth = actualScreenshareWidth * ratio;
                leftRightBlackBarSize = (feedWidth - convertedWidth) / 2;
            }

            return { topBottom: topBottomBlackBarSize, leftRight: leftRightBlackBarSize };
        }

        function getHasScreensharePermission() {
            if (screensharePermission !== null) {
                return Promise.resolve(screensharePermission);
            }

            return helperService.hasScreenRecordingPermissions().then(hasPermissions => {
                screensharePermission = hasPermissions;
                return screensharePermission;
            });
        }

        // ANYAM-67860: hack to trigger macOS '%AppName% would like to record this computer's screen' system dialog
        // Works only on the first call, with no app in System Preferences list.
        function triggerScreensharePermissionsSystemDialog() {
            return new Promise(resolve => {
                if (
                    helperService.isMac() &&
                    helperService.isElectron() &&
                    $window.preloadedApi.desktopCapturer.isAvailable()
                ) {
                    // No need to wait for Promise, just call electron API method
                    const options = { types: ['screen'] };
                    resolve($window.preloadedApi.desktopCapturer.getSources(options));
                }
                resolve();
            });
        }

        ////////////////////////
        // CITRIX V4 FUNCTIONS
        ////////////////////////

        // Citrix V4 API
        function startScreenShare_citrixV4(data) {
            // Check if this is a Citrix V4 screen share
            if (helperService.isCitrixSDKVersionFour?.() && data.id) {
                logger.log('electron-screen-selected', 'Using Citrix V4 APIs for screen capture', data);

                // Extract the Citrix source ID from the data displayId
                const sourceId = data.displayId;

                if (!sourceId) {
                    logger.error('electron-screen-selected', 'source id not available');
                    contentService.cancelContentInitiation();
                    return;
                }

                // Get VDI reference once for multiple calls
                const vdiRef = helperService.getVDIRef();

                // Step 1: Set the screen share panel ID using Citrix API
                vdiRef.setScreenSharePanelId?.(sourceId);

                // Step 2: Use Citrix getDisplayMedia to get the stream
                const constraints = {
                    video: {
                        width: { max: 1920 },
                        height: { max: 1080 },
                        frameRate: { max: 5 }
                    },
                    audio: false
                };

                logger.log('electron-screen-selected', 'Using VDIRef.getDisplayMedia with constraints', constraints);

                vdiRef
                    .getDisplayMedia?.(constraints)
                    .then(stream => {
                        logger.log('electron-screen-selected', 'Citrix capture stream obtained');

                        // Set the stream for use in screen sharing
                        useVideoStream = stream;

                        // Set the stream for SFU mode if enabled
                        if (meetingService.getIsSfuEnabled()) {
                            service.setCamaroSfuScreenShareStream(stream);
                            service.finalizeScreenShareInit();
                        } else {
                            service.finalizeScreenShareInit();
                        }
                    })
                    .catch(error => {
                        logger.error('electron-screen-selected', 'Error starting Citrix capture', error);
                        contentService.cancelContentInitiation();
                    });

                return;
            }
        }
    }
]);
